import apiClient from '../plugins/axios';

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem("token") || "",
    user: {},
    searchResults: [],
    searchLoading: false,
  }),
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    setSearchResults(state, results) {
      state.searchResults = results;
    },
    setSearchLoading(state, isLoading) {
      state.searchLoading = isLoading;
    },
  },
  actions: {
    async search({ commit }, searchTerm) {
      if (searchTerm.length < 3) {
        commit("setSearchResults", []);
        return;
      }
      commit("setSearchLoading", true);
      try {
        const response = await apiClient.get(`/search/searchDB`, {
          params: { search: searchTerm },
        });
        commit("setSearchResults", response.data);
      } catch (error) {
        console.error("Error during search:", error);
        commit("setSearchResults", []);
      } finally {
        commit("setSearchLoading", false);
      }
    },
    resetSearchResults({ commit }) {
      commit("setSearchResults", []);
    },
  },
  getters: {
    isAuthenticated(state) {
      return !!state.token;
    },
    searchResults(state) {
      return state.searchResults;
    },
    searchLoading(state) {
      return state.searchLoading;
    },
  },
};
